import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import { logout } from '~/redux/actions/authActions';
import { rootRoutes } from '~/common/routerConfig';

class Logout extends Component {
  componentDidMount() {
    const { isLoggedIn, logout } = this.props;
    if (isLoggedIn) {
      logout();
    }
  }

  render() {
    const { isLoggedIn } = this.props;
    return isLoggedIn ? null : <Redirect to={rootRoutes.login} />;
  }
}

Logout.propTypes = {
  logout: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool
};

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn
});

const mapDispatchToProps = {
  logout
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout);
